'use client';
import { IJWTPayload } from '@/src/shared/api/auth';
import { getClientSessionData } from '@/src/shared/api/auth/clientSession';
import { SessionContext } from '@/src/shared/lib/session';
import React, { useEffect, useState, useCallback } from 'react';

export const SessionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [userData, setUserData] = useState<IJWTPayload | null>(null);
  const [loading, setLoading] = useState(true);

  const refreshSession = useCallback(() => {
    setLoading(true);
    getClientSessionData()
      .then((sessionUserData) => {
        setUserData(sessionUserData);
      })
      .catch(() => {
        setUserData(null);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const setSessionData = useCallback((data: IJWTPayload | null) => {
    setUserData(data);
    setLoading(false);
  }, []);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    refreshSession();
  }, [refreshSession]);

  return (
    <SessionContext.Provider value={{ userData, loading, refreshSession, setSessionData }}>
      {children}
    </SessionContext.Provider>
  );
};
